import React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { breakpoint } from "src/library/utils";

import { Icon } from "../Icon";
import { Icons } from "../Icon/types";
import { Text } from "../Text";

export type CurrentView = "table" | "grid";

interface GridViewButtonProps {
toggleCallBack: (view: CurrentView) => void,
view: CurrentView
}

/**
 * Creates a button designed for switching between grid and table view
 * @returns
 */
const GridViewButton: React.FunctionComponent<GridViewButtonProps> = ({ toggleCallBack, view }) => {
  return (
    <ViewButtonWrapper>
      <Grid.Box
        className="toggle-view"
        onClick={() => view === "table" ? toggleCallBack("grid") : toggleCallBack("table")}
      >
        <Icon
          className="view-toggle-icon"
          $fillColor="primaryDark"
          icon={view === "table" ? Icons.GRID : Icons.TABLE}
          size={20}
        />

        <Text
          className="toggle-text"
          weight="bold"
        >
          {`Switch to ${view === "table" ? "grid" : "table"} view`}
        </Text>
      </Grid.Box>
    </ViewButtonWrapper>
  );
};

export const ViewButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;

    div {
      display: flex;
      align-items: center;
      padding-left: 24px;
      cursor: pointer;
    
      &:first-child {
        padding-left: 0;
      }
    
      .toggle-text {
        display: none;
        ${({ theme }) => breakpoint("sm", theme)} {
          display: inline;
        }
      }
    
      span,
      svg {
        transition: ${theme.transition.quickest};
      }
    
      span {
        padding-left: 6px;
      }
    
      &:hover,
      &.active {
        span {
          color: ${theme.colors.primaryDark};
        }
    
        svg {
          fill: ${theme.colors.primaryDark};
        }
      }
    }
  }`}`;

export default GridViewButton;
